import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-genesis.svg'
import _imports_1 from '@/app/ui/assets/svg/sparkles.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'
import _imports_3 from '@/app/ui/assets/svg/arrow-circle-left.svg'


const _hoisted_1 = { class: "bg-gray-lp-100 h-full min-h-screen w-screen items-center justify-center flex flex-col font-montserrat px-8" }
const _hoisted_2 = { class: "flex flex-col w-full max-w-400px mx-auto text-12px xxl:text-14px" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-44 xxl:w-64",
  alt: "logo genesis"
}, null, -1)
const _hoisted_4 = { class: "font-semibold text-black-lp-100 text-28px lg:text-36px xxl:text-42px py-4" }
const _hoisted_5 = { class: "flex flex-row p-6 bg-gray-lp-200 rounded-md text-gray-lp-300 mt-2 items-start" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3",
  alt: "sparkles"
}, null, -1)
const _hoisted_7 = { class: "inline-block relative w-full" }
const _hoisted_8 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "h-4 xxl:h-5 mr-3",
  alt: "exclamation circle solid"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-5 mr-3",
  alt: "arrow circle left"
}, null, -1)
const _hoisted_11 = { class: "text-gray-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("forgotPassword.title")), 1),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("span", null, _toDisplayString(_ctx.$t("forgotPassword.hint")), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _withDirectives(_createVNode("input", {
            "data-testid": "auth-forgot-password-input-email",
            type: "email",
            name: "email",
            placeholder: _ctx.$t('forgotPassword.emailPlaceholder'),
            class: ["block appearance-none w-full bg-white border\n        focus:border-red-lp-100 px-3 xxl:px-4 py-2 xxl:py-3 pr-8 my-4 rounded\n        shadow leading-tight focus:outline-none focus:shadow-outline", {
            'border-red-500': _ctx.isError || _ctx.emptyEmail,
            'border-gray-lp-400': !_ctx.isError && !_ctx.emptyEmail
          }],
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.email = $event))
          }, null, 10, ["placeholder"]), [
            [_vModelText, _ctx.form.email]
          ]),
          _withDirectives(_createVNode("div", _hoisted_8, [
            _hoisted_9
          ], 512), [
            [_vShow, _ctx.isError || _ctx.emptyEmail]
          ])
        ]),
        _withDirectives(_createVNode("p", { class: "text-xs text-red-600 px-4 mb-4" }, _toDisplayString(_ctx.$t("forgotPassword.errorEmptyEmail")), 513), [
          [_vShow, _ctx.emptyEmail]
        ]),
        _withDirectives(_createVNode("p", { class: "text-xs text-red-600 px-3 xxl:px-4 mb-4" }, _toDisplayString(_ctx.$t("forgotPassword.errorInvalidEmail")), 513), [
          [_vShow, _ctx.isError]
        ]),
        _createVNode(_component_button_fill, {
          "data-testid": "auth-forgot-password-button-submit",
          title: _ctx.$t('forgotPassword.submitButton'),
          onClick: _ctx.submitEmail,
          isLoading: _ctx.isLoading
        }, null, 8, ["title", "onClick", "isLoading"]),
        _createVNode("button", {
          "data-testid": "auth-forgot-password-link-back-login",
          class: "flex flex-row mt-4 focus:outline-none",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args)))
        }, [
          _hoisted_10,
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("forgotPassword.backToLogin")), 1)
        ])
      ]),
      _createVNode(_component_Footer)
    ]),
    (_ctx.isErrorInternetOrSystem)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.submitEmail,
          modal: ""
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModal,
      title: 
      _ctx.isVerified
        ? _ctx.$t('forgotPassword.modalSuccessTitle')
        : _ctx.$t('forgotPassword.modalFailTitle')
    ,
      message: 
      _ctx.isVerified
        ? _ctx.$t('forgotPassword.modalSuccessMessage', { email: `<b>${_ctx.form.email}</b>` })
        : _ctx.$t('forgotPassword.modalFailMessage', { email: `<b>${_ctx.form.email}</b>` })
    ,
      email: _ctx.form.email,
      image: _ctx.isVerified ? 'sended' : 'rejected',
      textSuccess: _ctx.$t('resetPasswordPage.ok')
    }, null, 8, ["onSubmit", "title", "message", "email", "image", "textSuccess"]), [
      [_vShow, _ctx.openModalFailed || _ctx.openModalSuccess]
    ])
  ], 64))
}